import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from './Home/home';
import OrderPage from './Orders/orderpage';
import OffersPage from './Offers/offerspage';
import Contact from './contact';
import ProtectedRoute from './protectedroute';
import AboutUs from './Landing/aboutus';
import Privacy, {FaqPage, Terms} from './privacy';
import LoginRoute from "./loginroute";
import ProfilePage from "./Profile/profilepage"
import BecomeRiderPage from './Contact/becomeriderpage';
import BecomePartnerPage from './Contact/becomepartnerpage';
import RegisterStorePage from './Contact/registerstorepage';
import TeamPage from './Landing/teampage';
import CareersPage from './careers';
import ScrollToTop from  "./scrolltop";
import NotFoundPage from "./notfoundpage";
import {HowToCustomer, HowToDelivery, HowToStore} from './Landing/howto';
import Booking from './Booking/booking';

export default class Routes extends Component {
    render() {
        return (
            <Router>
                <ScrollToTop>
                    <Switch>
                        <Route exact path="/" component={AboutUs} />
                        <Route path="/faqs" component={FaqPage} />
                        <Route path="/team" component={TeamPage} />
                        <LoginRoute path="/login" component={Home} />
                        <ProtectedRoute path="/orders" component={OrderPage} />
                        <ProtectedRoute path="/offers" component={OffersPage} />
                        <Route path="/careers" component={CareersPage} />
                        <ProtectedRoute path="/profile" component={ProfilePage} />
                        <Route path="/book-now" component={Booking} />
                        <Route path="/register-store" component={RegisterStorePage} />
                        <Route path="/contact-us" component={Contact} />
                        <Route path="/become-a-rider" component={BecomeRiderPage} />
                        <Route path="/become-a-partner" component={BecomePartnerPage} />
                        <Route path="/privacy-policy" component={Privacy} />
                        <Route path="/how-to-use-store" component={HowToStore} />
                        <Route path="/how-to-use-delivery" component={HowToDelivery} />
                        <Route path="/how-to-use-customer" component={HowToCustomer} />
                        <Route path="/terms-and-conditions" component={Terms} />
                        <Route component={NotFoundPage} />
                    </Switch>
                </ScrollToTop>
            </Router>
        )
    }
}
